import axios from 'axios'

if (process.env.VUE_APP_API_URL_MODE === 'development') {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL_DEV
} else {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL_PROD
}

export default axios
